module.exports = {
	"firstName": "lisa",
	"name": "lisa fiege",
	"shortname": "lisa-fiege",
	"website_handle": "thelfashion.com",
	"website_url": "http://www.thelfashion.com/",
	"instagram_handle": "thelfashion",
	"instagram_url": "https://www.instagram.com/thelfashion/?hl=en",
	"description": "Based in Cologne, Germany, Lisa is the fashion brain behind The L Fashion. Always experimenting with fashion trends, Lisa enjoys combining different styles to create a unique look. See Noisy may through her eyes in this collection.",
	"interview": [
		{
			"title": "1. What is your favorite piece in the collection?",
			"description": "It’s definitely the oversized T-Shirt which is inspired by the band shirts that are everywhere in my closet. T-Shirts like this are the base element of almost every of my outfits. I like to wear them with Skinny Jeans and especially as a dress with edgy boots and fishnets, that’s the reason why I wanted to make this T-Shirt really oversized."
		},
		{
			"title": "2. How would you describe your fashion journey?",
			"description": "It was definitely a wild ride, it took me a long time to find my personal style, from feminine to edgy, I tried everything during my five years of blogging. But now I don’t care about ‚Fashion rules’ and trends anymore, I wear what I like. My style is now inspired by the things I really admire, like Rock’n’Roll music, it allows you to go all out."
		},
		{
			"title": "3. Jeans or dresses?",
			"description": "Jeans over dresses, no questions asked! It’s rare that I wear dresses and when I do, I actually wear them over jeans or with something else to give them more of an edgy style."
		}
	],
	"quote": "I always wanted to create something inspired by my favorite music, something edgy and Rock’n’Roll",
	"media": [
		"/media/img/influencers/lisa/lisa-fiege_slider-4.jpg",
		"/media/img/influencers/lisa/lisa-fiege_slider-3.jpg",
		"/media/img/influencers/lisa/lisa-fiege_slider-2.jpg",
		"/media/img/influencers/lisa/lisa-fiege_slider-1.jpg"
	],
	"socialItems": [
		{
			"url": "https://www.instagram.com/p/BI9ujngg0pE/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/13774601_1202311086455578_801575431_n.jpg?ig_cache_key=MTMxNDQxMTQyNDAwNDY1NTY4NA%3D%3D.2",
			"likes": 816
		},
		{
			"url": "https://www.instagram.com/p/BJf-E1TAH78/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14052272_1762276260698799_145655099_n.jpg?ig_cache_key=MTMyNDA0OTgyNjQ1ODkyNjg0NA%3D%3D.2",
			"likes": 643
		},
		{
			"url": "https://www.instagram.com/p/BKaKSiHg2Hf/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14240655_1051598108295168_2126683556_n.jpg?ig_cache_key=MTM0MDQyOTA5MzE0NTEwODk1OQ%3D%3D.2",
			"likes": 626
		},
		{
			"url": "https://www.instagram.com/p/BMI9DSEAgKx/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14360007_328449424199996_6526893299574243328_n.jpg?ig_cache_key=MTM3MTYxNDU5MjkyNDUxNzA0MQ%3D%3D.2",
			"likes": 807
		},
		{
			"url": "https://www.instagram.com/p/BMTxEn6AAdB/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/14693926_1774780636123008_6377069545911222272_n.jpg?ig_cache_key=MTM3NDY1ODEzMzI4NDA5NTgwOQ%3D%3D.2",
			"likes": 854
		},
		{
			"url": "https://www.instagram.com/p/BNMgs98gM-F/",
			"img": "https://scontent-ams3-1.cdninstagram.com/t51.2885-15/e35/15057177_213325372446641_384145980942974976_n.jpg?ig_cache_key=MTM5MDYzMDIxMjYwOTI5ODMwOQ%3D%3D.2",
			"likes": 556
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./data/influencers/lisa-fiege.json
// module id = 76
// module chunks = 0